import React from 'react';
import { ConfiguableSvgProps } from './types';

const Info = ({ color, className }: ConfiguableSvgProps) => {
	return (
		<svg
			width="16"
			height="16"
			viewBox="0 0 16 16"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			className={className}
		>
			<path
				d="M7.83333 13.6667C11.055 13.6667 13.6667 11.055 13.6667 7.83333C13.6667 4.61167 11.055 2 7.83333 2C4.61167 2 2 4.61167 2 7.83333C2 11.055 4.61167 13.6667 7.83333 13.6667Z"
				stroke={color ?? '#6683A7'}
				strokeWidth="1.19"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.8335 10.1668V7.8335"
				stroke={color ?? '#6683A7'}
				strokeWidth="1.19"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M7.8335 5.5H7.84016"
				stroke={color ?? '#6683A7'}
				strokeWidth="1.19"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
};

export default Info;
